"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styles_1 = require("@material-ui/core/styles");

var useStyles = (0, styles_1.makeStyles)(function () {
  return {
    section: {
      background: '#f5f5f5',
      borderBottom: '2px dotted #606060',
      display: 'block',
      padding: '15px 5px',
      textAlign: 'center'
    }
  };
});
exports.default = useStyles;